import PropTypes from "prop-types";
import { forwardRef } from "react";
import { v4 as uuidv4 } from "uuid";
import classes from "./Radio.module.scss";

export const Radio = forwardRef(
  ({ name, label, defaultChecked, ...props }, ref) => {
    const radioId = uuidv4();
    return (
      <div className={classes["wrapper"]}>
        <input
          type="radio"
          name={name}
          id={radioId}
          className={classes["radio"]}
          defaultChecked={defaultChecked}
          {...props}
          value={props.value || ""}
          ref={ref}
        />

        <label htmlFor={radioId} className={classes["label-wrapper"]}>
          <div
            className={`${classes["radio-label"]}`}
            data-testid={"radio-label"}
          >
            <span className={`${classes["icon"]}`} />
          </div>
          <div className={classes["label-text"]}>{label}</div>
        </label>
      </div>
    );
  }
);

Radio.propTypes = {
  /**
   * name of the input tag
   */
  name: PropTypes.string,
  /**
   * label to be shown beside the radio button
   */
  label: PropTypes.string,
  //TODO: write tests for default checked
  /**
   * set true to default check the radio
   */
  defaultChecked: PropTypes.bool,
};

Radio.defaultProps = {
  name: undefined,
  label: undefined,
};
